module.exports = __webpack_public_path__ + "static/media/banner2.7e985493.png";